import { Component, computed, input, signal } from '@angular/core';
import { DrawerMenuItem } from '@assethub/shared/models';
import { CustomSvgIcons, UserConfigurationService } from '@assethub/shared/services';
import { take } from 'rxjs';
import { DrawerNavigationItemComponent } from '../drawer-navigation-item/drawer-navigation-item.component';

@Component({
  selector: 'app-drawer-navigation',
  templateUrl: './drawer-navigation.component.html',
  styleUrls: ['./drawer-navigation.component.scss'],
  imports: [DrawerNavigationItemComponent],
})
export class DrawerNavigationComponent {
  readonly navItems = input.required<DrawerMenuItem[]>();
  readonly expanded = signal(false);
  readonly isExpandStateLocked = signal(false);
  readonly lockStateIcon = computed(() =>
    this.isExpandStateLocked()
      ? this.customIcons.custom_pin_off_outline
      : this.customIcons.custom_pin_outline,
  );
  readonly expandStateIcon = computed(() =>
    this.expanded() ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right',
  );

  constructor(
    private customIcons: CustomSvgIcons,
    private userConfigService: UserConfigurationService,
  ) {
    this.userConfigService
      .config()
      // The first event will include the default config (expanded = false).
      // The second event will include the config loaded from locale storage.
      .pipe(take(2))
      .subscribe(config => {
        this.isExpandStateLocked.set(config.navDrawerExpanded);
        this.expanded.set(config.navDrawerExpanded);
      });
  }

  toggleExpandState() {
    this.expanded.set(!this.expanded());
  }

  persistExpandMode() {
    const nextLockState = !this.isExpandStateLocked();
    this.isExpandStateLocked.set(nextLockState);
    this.userConfigService.setNavDrawerExpanded(nextLockState);
  }
}
